let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ifAt9"), load("HYlkB"), load("aoJPa")]).then(() => parcelRequire('kaQDe'));